import React, { useState } from "react";
import QaReportForm from "./QaReportForm";
import { Button } from "@mui/material";
import PopUps from "./PopUps";

const QaReportPopUp = ({ data }) => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const componetProps = {
        row: data,
    };

    return (
        <div>
            <Button variant="contained" onClick={handleClick}>
                View
            </Button>

            <PopUps
                open={open}
                setOpen={setOpen}
                componentProps={componetProps}
                component={QaReportForm}
            />
        </div>
    );
};

export default QaReportPopUp;
